import React, { useState, useEffect } from 'react';
import { TrashIcon, MailIcon } from '../../components/icons/Icons';
import api from '../../services/api';
import AdminLayout from './AdminLayout';
import './Messages.css';

const Messages = () => {
  const [messages, setMessages] = useState([]);
  const [selectedMessage, setSelectedMessage] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchMessages();
  }, []);

  const fetchMessages = async () => {
    try {
      const response = await api.get('/contact');
      setMessages(response.data);
    } catch (error) {
      console.error('Failed to fetch messages:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleSelect = async (message) => {
    setSelectedMessage(message);
    if (!message.is_read) {
      try {
        await api.get(`/contact/${message.id}`);
        setMessages(messages.map(m => 
          m.id === message.id ? { ...m, is_read: true } : m
        ));
      } catch (error) {
        console.error('Failed to mark as read:', error);
      }
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Are you sure you want to delete this message?')) return;

    try {
      await api.delete(`/contact/${id}`);
      setMessages(messages.filter(m => m.id !== id));
      if (selectedMessage?.id === id) {
        setSelectedMessage(null);
      }
    } catch (error) {
      alert('Failed to delete message');
    }
  };

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  return (
    <AdminLayout>
      <div className="admin-page-header">
        <h1 className="admin-page-title">Messages</h1>
      </div>

      <div className="messages-container">
        <div className="messages-list admin-card">
          {loading ? (
            <p className="messages-empty">Loading messages...</p>
          ) : messages.length === 0 ? (
            <p className="messages-empty">No messages yet</p>
          ) : (
            messages.map(message => (
              <div
                key={message.id}
                className={`message-item ${selectedMessage?.id === message.id ? 'active' : ''} ${!message.is_read ? 'unread' : ''}`}
                onClick={() => handleSelect(message)}
              >
                <div className="message-item-header">
                  <span className="message-sender">{message.name}</span>
                  {!message.is_read && <span className="unread-dot"></span>}
                </div>
                <p className="message-subject">{message.subject || 'No subject'}</p>
                <span className="message-date">{formatDate(message.created_at)}</span>
              </div>
            ))
          )}
        </div>

        <div className="message-detail admin-card">
          {selectedMessage ? (
            <>
              <div className="message-detail-header">
                <div>
                  <h2>{selectedMessage.subject || 'No subject'}</h2>
                  <p className="message-meta">
                    From: <strong>{selectedMessage.name}</strong> ({selectedMessage.email})
                    {selectedMessage.phone && <> | Phone: {selectedMessage.phone}</>}
                  </p>
                  <p className="message-meta">
                    Received: {formatDate(selectedMessage.created_at)}
                  </p>
                </div>
                <button
                  onClick={() => handleDelete(selectedMessage.id)}
                  className="admin-btn-icon admin-btn-delete"
                >
                  <TrashIcon size={18} />
                </button>
              </div>
              <div className="message-body">
                {selectedMessage.message}
              </div>
              <div className="message-actions">
                <a
                  href={`mailto:${selectedMessage.email}?subject=Re: ${selectedMessage.subject || 'Your inquiry'}`}
                  className="btn btn-primary"
                >
                  <MailIcon size={18} /> Reply via Email
                </a>
              </div>
            </>
          ) : (
            <div className="message-placeholder">
              <MailIcon size={48} />
              <p>Select a message to view</p>
            </div>
          )}
        </div>
      </div>
    </AdminLayout>
  );
};

export default Messages;
